import React, { useEffect, useState, memo } from 'react'
import { Avatar as MuiAvatar, CircularProgress } from '@material-ui/core'
import { storageRef } from '../index'
import { Box } from '@mui/material'

const AvatarComponent = ({
  conferenceId,
  imageProps,
  imageName,
  variant,
  path,
  height = 150,
  width = 150,
  progressSize = 32,
  key = 'avatar-image'
}) => {
  const [image, setImage] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (imageName) {
      downloadImage()
    }
    return () => setImage(null)
  }, [imageName, conferenceId, path])

  const downloadImage = async () => {
    try {
      if (imageName) {
        setLoading(true)
        const imageUrl = await storageRef
          .child(`${conferenceId}/${path}/${imageName}`)
          .getDownloadURL()
        setImage(imageUrl)
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      // do nothing
    }
  }

  return (
    <>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: '0.25rem' }}>
          <CircularProgress size={progressSize} />
        </Box>
      ) : (
        <MuiAvatar
          key={key}
          variant={variant}
          style={{
            border: '1.25px solid #c2c2c2',
            height: height,
            width: width,
            margin: 0
          }}
          imgProps={imageProps}
          src={image}
        />
      )}
    </>
  )
}

// Apply memoization to the component
const Avatar = memo(AvatarComponent)

// Set display name for React DevTools
Avatar.displayName = 'Avatar'

export default Avatar
